
import { useState } from 'react';

import { Link } from 'react-router';

import { Button, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';

import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

import { FaChevronDown } from "react-icons/fa6";

import { ListItembuttonStyle, ListItemIconStyle, ListItemTextStyle, ListTypographyStyle, MenuItemStyle, TypographyAppBarStyle } from '../../styles/ListItemStyle';

export const ListItemAdministracion = () => {

    const [anchorEl, anchorElOpen] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleOpen = ( e: React.MouseEvent<HTMLButtonElement, MouseEvent> ) => {
        anchorElOpen( e.currentTarget );
    };
    
    const handleClose = () => {
        anchorElOpen( null );
    };

    return (
        <>
        
            <ListItemText style={ ListItemTextStyle }>
        
                <Button color="inherit" style={ ListItembuttonStyle } onClick={ handleOpen }>

                    <AdminPanelSettingsIcon style={{ ...ListItemIconStyle, fontSize: 20 }} />

                    <Typography sx={{ ...ListTypographyStyle, display: { xs: 'none', lg: 'flex' } }} >
                        Administración
                    </Typography>     
                    
                    <FaChevronDown style={ ListItemIconStyle } />  

                </Button>

            </ListItemText>

            <Menu 
                elevation={ 2 } 
                anchorEl={ anchorEl } 
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }} 
                keepMounted open={ open } 
                onClose={ handleClose }
            >

                <Link to="/administracion/administracion-casos/" style={{ textDecoration: 'none' }}>
                    <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ handleClose } > 
                        <ListItemIcon> <AdminPanelSettingsIcon /> </ListItemIcon>
                        <ListItemText style={TypographyAppBarStyle}>Administración de casos</ListItemText>
                    </MenuItem>
                </Link>
     
                <Link to="/administracion/plantillas/" style={{ textDecoration: 'none' }}>
                    <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ handleClose } > 
                        <ListItemIcon> <AdminPanelSettingsIcon /> </ListItemIcon>
                        <ListItemText style={TypographyAppBarStyle}>Plantilla(s)</ListItemText>
                    </MenuItem>
                </Link>
               
            </Menu>
        
        </>        
    )
}